import React from 'react'
import styled from 'styled-components'

const RadioLabelElement = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 200;
  margin-bottom: 0 !important;
`

const RadioInputElement = styled.input`
  margin: 0 0.5rem !important;
  width: 0.7rem;
  transform: scale(1.2);
  opacity: 0.8;
`
const RadioButton = React.forwardRef(({ label, ...restOfProps }, ref) => {
  return (
    <RadioLabelElement>
      <RadioInputElement innerRef={ref} type="radio" {...restOfProps} />
      {label}
    </RadioLabelElement>
  )
})

export default RadioButton
